var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"info-box"},on:{"click":_vm.handlerApplicationForm}},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"big-info-header"},[_vm._v(_vm._s(_vm.$t("infoBox.title")))]),_c('span',{staticClass:"big-info-sub"},[_vm._v(_vm._s(_vm.$t("infoBox.subTitle")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }